import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setSubTitle } from "../stores/AppReducer";
import { AppDispatch } from "../stores/AppStore";

function Welcome () {
    const dispatch = useDispatch<AppDispatch>();
    
    useEffect(() => {
        dispatch(setSubTitle("Willkommen"));
    }, []);    
    return (
        <div className="text">
            <p>Du hast eine Einladung bekommen und kannst dich hier umschauen.</p>
            <p>Oben in der Mitte, siehts du die Optionen, die für dich freigeschaltet sind. (z.B. Bilder)</p>
            <p>Wenn du dir ein Lesezeichen speicherst, dann kannst du die Website auch später von dem gleichen Browser aus aufrufen.</p>
            <p>Oder du nutzt den Link aus der Einladungs-Mail, um auch von anderen Geräten aus auf die Cloud zuzugreifen.</p>
            <p>Oder klicke <a className="normalLink" href="#register">hier</a>, um dir ein eigenes Passwort zu geben.
                Dann kannst du dich auch ohne Einladung jederzeit auf <a className="normalLink" 
                href="https://microfix.de#login"> Microfix.de </a>anmelden.
            </p>
        </div>
    );
};
export default(Welcome);
